import {
  NavigationState,
  useNavigationState,
  PartialState,
} from "@react-navigation/native";
import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";

import { NoNav_atom } from "../atoms";

export const useShouldHideNav = () => {
  const [hideNav, setHideNav] = useState(false);
  const isNoNav = useAtomValue(NoNav_atom);

  // Get current route name from navigation state
  const routeName = useNavigationState((state) => {
    const getActiveRouteName: (
      navigationState: NavigationState | PartialState<NavigationState>
    ) => string | null = (
      navigationState: NavigationState | PartialState<NavigationState>
    ) => {
      if (!navigationState?.routes || navigationState.index === undefined)
        return null;

      const activeRoute = navigationState.routes[navigationState.index];

      if (activeRoute?.state) {
        return getActiveRouteName(activeRoute.state);
      }

      return activeRoute?.name;
    };

    return getActiveRouteName(state);
  });

  useEffect(() => {
    const hideTabBarScreens = [
      "Agenda",
      "BookingDetail",
      "Lessons",
      "JoinBooking",
      "MoveBooking",
      "BookingSummary",
      "DepartmentAvailability",
      "Memberships",
      "MembershipsList",
      "MembershipDetail",
      "MembershipOrder",
      "Packages",
      "PackagesList",
      "PackageDetail",
      "PackageOrder",
      "Events",
    ];

    setHideNav(isNoNav || hideTabBarScreens.includes(routeName ?? ""));
  }, [routeName, isNoNav]);

  return hideNav;
};
